import React from 'react';
import PropTypes from 'prop-types';
import { connectModal } from 'redux-modal';
import cn from 'classnames';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { useDispatch, useSelector } from 'react-redux';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { ACCOUNT_MODAL, LOGIN_MODAL } from '../../../constants/modal-constants';
import { TYPE_AUTH_TITLE } from '../../../constants/account-contants';
import * as modalActions from '../../../actions/modal-actions';
import closeIcon from '../../../assets/images/close-icon.svg';
import { CopyIcon, ViewIcon } from '../../../constants/icon-constants';
import cutWalletAddress from '../../../util/cutWalletAddress';
import networkHelpers from '../../../helpers/network.helpers';
import networkConstants from '../../../constants/network.constant';
import Omv2 from './balanceItem/omv2';
import Rfuel from './balanceItem/rfuel';
import Uni from './balanceItem/uni';
import Univ2 from './balanceItem/univ2';
import { OM_STAKING_MIGRATE_STATUS } from '../../../constants/blockchain-constants';
import Om from './balanceItem/om';
import Roya from './balanceItem/roya';
import Fxf from './balanceItem/fxf';
import LabsUni from './balanceItem/labs-uni';
import L3p from './balanceItem/l3p';
import Omv3 from './balanceItem/omv3';
import Labs from './balanceItem/labs';
import Pkf from './balanceItem/pkf';
import Kyl from './balanceItem/kyl';
import BnbFine from './balanceItem/fine';
import Raze from './balanceItem/raze';
import config from '../../../config/env';

import s from './account-modal.module.scss';
import BnbOm from './balanceItem/bnb-om';
import RazeEth from './balanceItem/raze-eth';
import BbankEth from './balanceItem/bbank-eth';
import BnbMist from './balanceItem/bnb-mist';
import Rosn from './balanceItem/rosn';
import BnbCbd from './balanceItem/bnb-cbd';
import BnbBbank from './balanceItem/bnb-bbank';
import BnbRosn from './balanceItem/bnb-rosn';
import BondlyEthUni from './balanceItem/bondly-eth-uni';
import BondlyUsdt from './balanceItem/bondly-usdt';
import BondlyWbnb from './balanceItem/bondly-wbnb';
import BondlyEth from './balanceItem/bondly-eth';
import BondlyBsc from './balanceItem/bondly-bsc';
import Bite from './balanceItem/bite';
import LabsGroup from './balanceItem/labs-group';
import BiteEthIntervals from './balanceItem/bite-eth-intervals';
import BiteEthUni from './balanceItem/bite-eth-uni';
import Bcube from './balanceItem/bcube';
import BcubeEthUni from './balanceItem/bcube-eth-uni';
import Mlt from './balanceItem/mlt';
import BnbMlt from './balanceItem/bnb-mlt';
import OmBsc from './balanceItem/om-bsc';
import OmPolygon from './balanceItem/om-polygon';
import GamerPolygon from './balanceItem/gamer-polygon';
import GamerWethPolygon from './balanceItem/gamer-weth-polygon';
import SRfuel from './balanceItem/srfuel';
import ZenUsdtOm from './balanceItem/zenusdt-om';
import ZenUsdcUni from './balanceItem/zenusdc-uni';
import ZenDaiUni from './balanceItem/zen-dai-uni';
import ZenUstUni from './balanceItem/zen-ust-uni';
import ZenWbtcUni from './balanceItem/zen-wbtc-uni';
import ZenEthUni from './balanceItem/zen-eth-uni';
import networkConstant from '../../../constants/network.constant';
import Cirus from './balanceItem/cirus';
import Skyrim from './balanceItem/skyrim';
// TODO: Uncomment this
// import Stfi from './balanceItem/stfi';
// import StfiWbnb from './balanceItem/stfiWbnb';
import L3pWbnb from './balanceItem/l3pWbnb';
// import Spwn from './balanceItem/spwn';

const AccountModal = ({ show }) => {
  const dispatch = useDispatch();
  const dark = useSelector((state) => state.basic.dark);
  const { address, auth: typeAuth, networkId } = useSelector((state) => state.account);
  const networkType = networkHelpers.findNetworkType(networkId);
  const { migrateStatus } = useSelector((state) => state.OMstake.stake);

  const showLoginModal = () => {
    dispatch(modalActions.showModal(LOGIN_MODAL));
  };

  return (
    <Dialog
      open={show}
      style={{ background: 'transparent' }}
      className={cn(s.dialog, { [s.dark]: dark })}
    >
      <div className={s.container}>
        <div className={s.header}>
          <div className={s.headerTitle}>MetaMask</div>
          <button
            className={s.close}
            onClick={() => dispatch(modalActions.hideModal(ACCOUNT_MODAL))}
          >
            <img src={closeIcon} alt='CLOSE' />
          </button>
        </div>
        <div className={s.body}>
          <div className={s.block}>
            <div className={s.blockHeader}>
              <div>
                <div className={s.blockHeaderTitle}>Connected with {TYPE_AUTH_TITLE[typeAuth]}</div>
                <div className={s.address}>
                  <div className={s.addressIcon} style={{ background: '#3AAA45' }} />
                  <div className={s.addressText}>{cutWalletAddress(address, 5)}</div>
                </div>
              </div>
              <Button variant='outlined' className={s.disconnect} onClick={() => showLoginModal()}>
                Connect
                <br />
                other Wallet
              </Button>
            </div>
            <div className={s.controls}>
              <CopyToClipboard text={address}>
                <button className={s.control}>
                  {CopyIcon}
                  Copy Address
                </button>
              </CopyToClipboard>
              {networkType === networkConstants.networkType.binance && (
                <a
                  href={`${config.REACT_APP_BSC_URL}/address/${address}`}
                  target='_blank noreferrer'
                  className={s.control}
                >
                  {ViewIcon}
                  View on BscScan
                </a>
              )}
              {networkType === networkConstants.networkType.polygon && (
                <a
                  href={`${config.REACT_APP_POLYGON_URL}/address/${address}`}
                  target='_blank noreferrer'
                  className={s.control}
                >
                  {ViewIcon}
                  View on Polygonscan
                </a>
              )}
              {networkType === networkConstants.networkType.ethereum && (
                <a
                  href={`${config.REACT_APP_ETHERSCAN_URL}/address/${address}`}
                  target='_blank noreferrer'
                  className={s.control}
                >
                  {ViewIcon}
                  View on Etherscan
                </a>
              )}
            </div>
          </div>
          <div className={s.balanceTable}>
            <div className={s.balanceTableHeader}>
              <div>Asset Balance</div>
              <div>Current Staked</div>
            </div>
            {networkType === networkConstants.networkType.binance && (
              <>
                <BnbFine />
                <BnbOm />
                <BnbMist />
                <Rosn />
                <BnbCbd />
                <BnbBbank />
                <BnbRosn />
                <BondlyWbnb />
                <BondlyBsc />
                <Mlt />
                <BnbMlt />
                <OmBsc />
                {/*TODO: Uncomment this*/}
                {/*<Stfi />*/}
                {/*<StfiWbnb />*/}
                <L3pWbnb />
              </>
            )}
            {networkType === networkConstant.networkType.polygon && (
              <>
                <OmPolygon />
                <GamerPolygon />
                <GamerWethPolygon />
              </>
            )}
            {networkType === networkConstants.networkType.ethereum && (
              <>
                {migrateStatus === OM_STAKING_MIGRATE_STATUS.HIDE_POOL ? (
                  <Omv2 />
                ) : (
                  <>
                    <Om />
                    <Omv2 />
                  </>
                )}
                <Omv3 />
                <ZenUsdtOm />
                <ZenUsdcUni />
                <ZenDaiUni />
                <ZenUstUni />
                <ZenWbtcUni />
                <ZenEthUni />
                <Rfuel />
                <Uni />
                <Univ2 />
                <Roya />
                <Fxf />
                <LabsUni />
                <Labs />
                <L3p />
                <Pkf />
                <Kyl />
                <Raze />
                <RazeEth />
                <BbankEth />
                <BondlyEthUni />
                <BondlyUsdt />
                <BondlyEth />
                <Bite />
                <BiteEthUni />
                <Bcube />
                <LabsGroup />
                <BiteEthIntervals />
                <BcubeEthUni />
                <SRfuel />
                <Cirus />
                <Skyrim />
                {/* TODO: Uncomment */}
                {/* <Spwn /> */}
              </>
            )}
          </div>
        </div>
      </div>
    </Dialog>
  );
};

AccountModal.propTypes = {
  show: PropTypes.bool,
};

AccountModal.defaultProps = {
  show: false,
};

export default connectModal({ name: ACCOUNT_MODAL })(AccountModal);
